import Arrow from "./img/arrow.svg?react";
import "./style.scss";

const btnClass = {
  base: "show-more-button-component",
  active: "show-more-button-component active",
};

export default function ShowMoreButton({
  showMore,
  setShowMore,
  copyLess,
  copyMore,
}) {
  return (
    <div
      onClick={() => setShowMore(!showMore)}
      className={showMore ? btnClass.active : btnClass.base}
    >
      <button>
        {showMore
          ? `${copyLess ? copyLess : "Weniger anzeigen"}`
          : `${copyMore ? copyMore : "Mehr anzeigen"}`}
      </button>
      <Arrow />
    </div>
  );
}
